module.exports = __webpack_public_path__ + "img/11n.3df81688.png";